import { useState } from 'react'
import FaqItem from '../FaqItem'

const faqs = [
  {
    q: 'Apakah identitas saya benar-benar aman?',
    a: 'Ya, identitas Anda sepenuhnya dilindungi. Sistem kami menggunakan enkripsi tingkat tinggi dan tidak menyimpan informasi yang dapat mengidentifikasi pelapor kecuali atas persetujuan Anda. Perlindungan ini juga diperkuat oleh regulasi perundang-undangan yang berlaku.',
  },
  {
    q: 'Apa yang terjadi setelah saya mengirimkan laporan?',
    a: 'Laporan Anda akan diterima dan diverifikasi oleh tim independen dalam 2×24 jam. Setelah diverifikasi, laporan akan diteruskan kepada unit yang berwenang untuk ditindaklanjuti. Seluruh proses dapat dipantau melalui kode pelapor yang Anda terima.',
  },
  {
    q: 'Dokumen apa saja yang bisa saya lampirkan?',
    a: 'Anda dapat melampirkan berbagai jenis bukti seperti foto, dokumen (PDF, DOC), rekaman audio/video, dan tangkapan layar. Semakin lengkap bukti yang disertakan, semakin mudah laporan Anda untuk diproses.',
  },
  {
    q: 'Apakah ada batas waktu untuk melaporkan?',
    a: 'Tidak ada batas waktu yang ketat. Namun kami menyarankan untuk melaporkan sesegera mungkin agar bukti dan informasi masih segar dan relevan, sehingga memudahkan proses penyelidikan.',
  },
  {
    q: 'Bagaimana jika laporan saya tidak ditindaklanjuti?',
    a: 'Jika Anda merasa laporan tidak ditindaklanjuti secara layak, Anda dapat mengajukan eskalasi melalui fitur yang tersedia di sistem. Laporan yang dianggap tidak ditindaklanjuti dapat dieskalasi langsung kepada Gubernur Kalimantan Selatan.',
  },
  {
    q: 'Apa yang dimaksud dengan kode pelapor?',
    a: 'Kode pelapor adalah nomor unik yang diberikan sistem kepada Anda saat laporan berhasil dikirim. Gunakan kode ini untuk login dan memantau perkembangan laporan tanpa perlu mengungkap identitas Anda.',
  },
]

export default function FaqSection() {
  const [openFaq, setOpenFaq] = useState(null)

  return (
    <section id="faq" className="py-24 bg-white">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <span className="text-blue-600 text-sm font-bold uppercase tracking-widest">FAQ</span>
          <h2 className="mt-3 text-3xl lg:text-4xl font-extrabold text-slate-900">Pertanyaan yang Sering Ditanyakan</h2>
          <p className="mt-4 text-slate-500">Temukan jawaban atas pertanyaan umum seputar WBS Kalimantan Selatan.</p>
        </div>
        <div className="space-y-3">
          {faqs.map((item, i) => (
            <FaqItem key={i} item={item} index={i} openFaq={openFaq} setOpenFaq={setOpenFaq} />
          ))}
        </div>
      </div>
    </section>
  )
}
